import React from 'react';
import Link from 'react-router';
import Moment from 'react-moment';
import { Meteor } from 'meteor/meteor';

import {
  Button
} from '@sketchpixy/rubix';

export default class PromotionListComponent extends React.Component {

  	render() {
  	  	return (
  	  	  	<tr>
              <td>{this.props.promotion.title}</td>
              <td><Moment format="DD/MM/YYYY">{this.props.promotion.createdAt}</Moment></td>
              <td><Moment format="DD/MM/YYYY">{this.props.promotion.editedAt}</Moment></td>
              <td>
                  <Button bsStyle="warning" onClick={this.goToEditView.bind(this)}>Modifier</Button>&nbsp;&nbsp;
                  <Button bsStyle="danger" onClick={this.deleteThisPrice.bind(this)}>Supprimer</Button>
              </td>
            </tr>
  	  	);
  	}

    deleteThisPrice() {
      Meteor.call('promotions.remove', this.props.promotion._id);
    }

    goToEditView() {
     this.context.router.push('/promotions/' + this.props.promotion._id);
    }

}

PromotionListComponent.propTypes = {
  // This component gets the task to display through a React prop.
  // We can use propTypes to indicate it is required
  promotion: React.PropTypes.object.isRequired,
};

PromotionListComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/promotions/component-promotions-list.js
 **/